import ContactForm from "./ui/ContactForm";
import GetInTouchForm from "./ui/GetInTouchFrom";

export default function ContactUsPage(){
    // update content ui with more details about contact us and eenhance ui
    return <main className="w-full flex justify-center items-center flex-1 bg-gray-50">
        <div className="container mx-auto px-4 py-16">
            <h1 className="text-4xl font-bold text-center text-purple-900 mb-8">Contact Us</h1>
            <p className="text-lg text-gray-700 text-center mb-12 max-w-3xl mx-auto">
                We'd love to hear from you! Whether you have a question about our services, need support, or just want to give feedback, feel free to reach out.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Contact Information */}
                <GetInTouchForm></GetInTouchForm>
                {/* Contact Form */}
               <ContactForm></ContactForm>
            </div>
        </div>
    </main>
    
    
}